<template>
    <div class="skillset">
      <SkillsetPage/>
    </div>
  </template>

<script>
import SkillsetPage from '@/components/SkillsetPage.vue'

export default {
  name: 'SkillsetView',
  components: {
    SkillsetPage
  }
}
</script>